import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import "./auth.css";

function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://airdrop-api-pe6y.onrender.com/api/register/', {
        username,
        email,
        password
      });

      setMessage('Registration successful! Redirecting...');
      setTimeout(() => navigate('/login'), 2000);

    } catch (err) {
      setMessage(err.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Create Account</h2>
        <p className="auth-subtitle">Join our crypto platform</p>

        <form onSubmit={handleRegister} className="auth-form">
          <input 
            className="auth-input"
            placeholder="Username" 
            value={username} 
            onChange={e => setUsername(e.target.value)} 
          />
          
          <input 
            className="auth-input"
            placeholder="Email" 
            value={email} 
            onChange={e => setEmail(e.target.value)} 
          />
          
          <input 
            className="auth-input"
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
          />

          <button className="auth-btn" type="submit">Register</button>
        </form>

        {message && <p className="auth-message">{message}</p>}
      </div>
    </div>
  );
}

export default Register;
